import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { envConfig } from '../configs/env'

const config: AxiosRequestConfig = {
  baseURL: envConfig.api.baseUrl
}

const axiosInstance: AxiosInstance = axios.create(config)

export { axiosInstance }
